import { render, staticRenderFns } from "./LoyaltyProgramForm.vue?vue&type=template&id=003898a0&lang=pug"
import script from "./LoyaltyProgramForm.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgramForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports